/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import FormInput from "../../../components/forms/form-Input";
import { INSURANCE_LIMIT_DEFAULT } from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";

export default function InsuranceLimits({
  insuranceLimits,
  currencies,
  updateDate,
  onValidityChange,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      ...INSURANCE_LIMIT_DEFAULT,
      insuranceLimits: [...insuranceLimits],
    },
  });

  const generalFieldProps = { control, errors };
  const formValidationRules = {
    customerId: { required: "Please add customer ID" },
    currency: { required: "Please select currency" },
    area: { required: "Please add area" },
    limit: {
      required: "Please add limit",
      validate: (value) => {
        if (!value || value === "0") return "Please add limit";
        return true;
      },
    },
  };
  const { fields: insuranceLimitFields, remove: insuranceLimitFieldRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "insuranceLimits",
    });
  useEffect(() => {
    if (updateDate) updateDate([...insuranceLimitFields]);
  }, [insuranceLimitFields]);

  useEffect(() => {
    const hasAtLeastOneWindow = insuranceLimitFields.length > 0;
    onValidityChange?.(hasAtLeastOneWindow);
  }, [insuranceLimitFields, onValidityChange]);

  const submitInfo = (data) => {
    const _limits = [...insuranceLimitFields];
    const newItem = {
      customerId: data.customerId,
      currency: data.currency,
      area: data.area,
      limit: data.limit,
    };
    if (currentEditing !== null) {
      _limits[currentEditing] = newItem;
      setCurrentEditing(null);
    } else {
      _limits.push(newItem);
    }
    reset({
      ...INSURANCE_LIMIT_DEFAULT,
      insuranceLimits: [..._limits],
    });
  };
  const onEditingCancel = () => {
    reset({
      ...INSURANCE_LIMIT_DEFAULT,
      insuranceLimits: [...insuranceLimitFields],
    });
    setCurrentEditing(null);
  };
  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Insurance Limit"
          cursor="pointer"
          onClick={() => {
            reset({
              ...INSURANCE_LIMIT_DEFAULT,
              ...dataItem,
              insuranceLimits: [...insuranceLimitFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Insurance Limit"
          cursor="pointer"
          onClick={() => {
            insuranceLimitFieldRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Insurance Limits</Heading>
      </Flex>

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Customer ID"
        name="customerId"
        rules={formValidationRules.customerId}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        data={
          currencies.map((item) => ({
            value: item.shortName,
            label: item.name,
          })) || []
        }
        placeholder="Select Currency"
        dropdownProps={{ filterable: true }}
        rules={formValidationRules.currency}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Area"
        name="area"
        rules={formValidationRules.area}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Limit"
        name="limit"
        rules={formValidationRules.limit}
      />
      <Grid data={insuranceLimitFields}>
        <GridColumn title="Customer Id" field="customerId" />
        <GridColumn title="Currency" field="currency" />
        <GridColumn title="Area" field="area" />
        <GridColumn title="Limit" field="limit" />
        <GridColumn title="Edit" cell={editCell} width={120} />
        <GridColumn title="Delete" cell={deleteCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button
            onClick={() => {
              onEditingCancel();
            }}
          >
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null
            ? "Update Insurance Limit"
            : "Add Insurance Limit"}
        </Button>
      </div>
    </form>
  );
}
